import { WORKFLOWS_ASSIGNMENT_ACCESS_LEGACY } from 'automation-ui-action-features/constants/Scopes';
import { convertToAssignableTeamOption } from 'automation-ui-action-features/users-and-teams/teamUtils';
import { GET_ASSIGNABLE_USER_IDS, GET_DEACTIVATED_USER_IDS } from 'automation-ui-action-features/users-and-teams/userQueries';
import AuthContext from 'automation-ui-core/context/AuthContext';
import { registerQuery, useQuery } from 'data-fetching-client';
import get from 'hs-lodash/get';
import intersection from 'hs-lodash/intersection';
import http from 'hub-http/clients/apiClient';
import { useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const GET_TEAMS = registerQuery({
  fieldName: 'teams',
  fetcher: () => http.get('app-users/v1/teams')
});
export const queryAssignableTeamOptions = WrappedComponent => props => {
  const {
    data: teamsData,
    error: teamsError,
    loading: loadingTeams
  } = useQuery(GET_TEAMS);
  const {
    data: assignableUserIdsData,
    error: assignableUserIdsError,
    loading: loadingAssignableUserIds
  } = useQuery(GET_ASSIGNABLE_USER_IDS);
  const {
    data: deactivatedUserIdsData,
    error: deactivatedUserIdsError,
    loading: loadingDeactivatedUserIds
  } = useQuery(GET_DEACTIVATED_USER_IDS);
  const auth = useContext(AuthContext);
  const scopes = get(auth, 'user.scopes', []);
  const isLegacied = scopes.includes(WORKFLOWS_ASSIGNMENT_ACCESS_LEGACY);
  const teams = get(teamsData, 'teams') || [];
  const assignableUserIds = get(assignableUserIdsData, 'assignableUserIds', []);
  const deactivatedUserIds = get(deactivatedUserIdsData, 'deactivatedUserIds', []);
  const assignableTeamsLoading = loadingTeams || loadingAssignableUserIds || loadingDeactivatedUserIds;
  const assignableTeamsError = teamsError || assignableUserIdsError || deactivatedUserIdsError;
  if (assignableTeamsError) {
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      assignableTeamOptions: [],
      assignableTeamsError: assignableTeamsError,
      assignableTeamsLoading: assignableTeamsLoading
    }));
  }
  const assignableTeamOptions = teams.map(team => {
    const _assignableUserIds = isLegacied ? team.userIds : intersection(team.userIds, assignableUserIds);
    const assignableAndDeactivatedUserIds = intersection(_assignableUserIds, deactivatedUserIds);
    return convertToAssignableTeamOption({
      team,
      assignableUsersCount: _assignableUserIds.length,
      deactivatedUsersCount: assignableAndDeactivatedUserIds.length
    });
  });
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    assignableTeamOptions: assignableTeamOptions,
    assignableTeamsError: assignableTeamsError,
    assignableTeamsLoading: assignableTeamsLoading
  }));
};